
/*
ABOUT >>
THIS INPUT USED FOR CREATE ADD EDIT OF MAIN SECTION DYNAMICLLY 
MAKE IT FULLY DYNAMIC  TO COVER CONDITIONS

ACTIVE >>
ITS NOT IN RUNNING POSITION 

UPDATES >>
NOT IN RUNNING POSITION MAKE IT
*/

import React from 'react';

const IrtizaDynamicInputAdd = (props) => {
    console.log(props)
    return (
        <div>
            
        </div>
    );
}



export default IrtizaDynamicInputAdd;
